import { inject, Injectable } from '@angular/core';
import { OutgoingEventsHandlerService } from './outgoing-events-handler.service';
import { BaseParamsService } from '@app/core/base-params.service';
import { filter, map, take } from 'rxjs/operators';
import { OutgoingEventsSenderService } from './outgoing-events/outgoing-events-sender.service';
import { EventTypes } from './outgoing-events/definitions/base-event';

@Injectable({ providedIn: 'root' })
export class MobileAppIntegrationService {
  private readonly outgoingEventsHandlerService = inject(OutgoingEventsHandlerService);
  private readonly baseParamsService = inject(BaseParamsService);

  private readonly outgoingEventsSenderService = inject(OutgoingEventsSenderService);

  public init(): void {
    this.baseParamsService.getParamsResolvedObservable().pipe(
      map(() => this.baseParamsService.isInsideMobileApp()),
      filter(isInsideMobileApp => isInsideMobileApp),
      take(1)
    ).subscribe(() => {
      this.outgoingEventsHandlerService.register();
    });
  }

  public triggerCameraAccess(): void {
    this.outgoingEventsSenderService.send({ type: EventTypes.TriggerCameraAccess });
  }
}
